import * as React from 'react';

export type MultilineTextProps = {
  children?: string;
};

export const MultilineText: React.FC<MultilineTextProps> = ({ children }) => {
  if (!children) {
    return null;
  }

  return (
    <React.Fragment>
      {children.split('\n').map((line, index) => (
        <React.Fragment key={index}>
          {index > 0 && <br />}
          {line}
        </React.Fragment>
      ))}
    </React.Fragment>
  );
};
